import React, { useState, useCallback } from 'react';
import { Modal, Button, Input, Form, Steps, Collapse, Spin } from 'antd';
import { CardElement, useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { processPayment, storeAchatFromClientDetailled, validateUserData } from '../services/offers/payment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import './Payment.css';
import { RiVisaLine, RiMastercardLine } from 'react-icons/ri';
import { FaPaypal } from "react-icons/fa";
import { CiCreditCard1 } from "react-icons/ci";


import { useTranslation } from 'react-i18next';
import Panel from 'antd/es/splitter/Panel';
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import i18n from '../i18n';

const { Step } = Steps;

const PaymentModal = ({ isOpen, onClose, offre,typePeyment }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [backupCodes, setBackupCodes] = useState(['', '', '', '']);
    const [whatsapp, setWhatsapp] = useState('');
    const [error, setError] = useState({});
    const [image, setImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [fileName, setFileName] = useState('');
    const navigate = useNavigate();
    const [cardBrand, setCardBrand] = useState('');
    const { t } = useTranslation();
    const [activeKey, setActiveKey] = useState(['1']);
    const locale = i18n.language;
    console.log(locale);
    const [isPaypalLoading, setIsPaypalLoading] = useState(false);

    const handleCardNumberChange = (event) => {
        if (event.complete) {
            setCardBrand(event.brand); // Set the detected card brand
            console.log(event.brand);
        } else if (event.error) {
            setCardBrand(''); // Clear the card brand on error
        } else {
            setCardBrand(event.brand); // Update as the user types
            console.log(event.brand);
        }
    };

    const stripe = useStripe();
    const elements = useElements();

    const handleBackupCodeChange = (index, value) => {
        const newBackupCodes = [...backupCodes];
        newBackupCodes[index] = value;
        setBackupCodes(newBackupCodes);
    };


    const StoreAchat = async (stripe_token) => {
        const data = new FormData();
        data.append('login', login);
        data.append('password', password);
        backupCodes.forEach((code, index) => {
            data.append(`backup_codes[${index}]`, code);
        });
        data.append('image', image);
        data.append('offre_id', offre.id);
        data.append('montant', offre.montant);
        data.append('stripe_token', stripe_token);
        data.append('whatsapp', whatsapp);

        try {
            await storeAchatFromClientDetailled(data).then((res) => {
                navigate(`/successful/${res.data.achat.id}/achat`)
            })
            onClose();
        } catch (err) {
            toast.error(t('failed to complete purchase'));
            console.error(err);
        }
    };

    const handleNext = async () => {
        if (currentStep === 0) {
            const data = new FormData();
            data.append('login', login);
            data.append('password', password);
            backupCodes.forEach((code, index) => {
                data.append(`backup_codes[${index}]`, code);
            });
            data.append('image', image);
            data.append('whatsapp', whatsapp);

            try {
                setIsLoading(true);
                const res = await validateUserData(data);
                if (res.status === 200) {
                    setCurrentStep((prev) => prev + 1);
                } else {
                    setError(res.data.errors);
                }
            } catch (err) {
                setError(err.response.data.errors);
                console.error(err.response.data.errors);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handlePrev = () => {
        setCurrentStep((prev) => prev - 1);
    };

    const handleSubmit = async () => {
        if (currentStep !== 1) {
            toast.error(t('please proceed to the payment step'));
            return;
        }

        const data = {
            amount: offre.montant,
        };

        try {
            setIsLoading(true);
            const res = await processPayment(data);
            const clientSecret = res.data.clientSecret;

            const cardNumber = elements.getElement(CardNumberElement);
            const cardExpiry = elements.getElement(CardExpiryElement);
            const cardCvc = elements.getElement(CardCvcElement);

            if (!cardNumber || !cardExpiry || !cardCvc) {
                throw new Error(t('card elements not found'));
            }

            const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    type: 'card',
                    card: cardNumber,
                    billing_details: {
                        address: {
                            postal_code: document.getElementById('postal-code').value
                        }
                    }
                }
            });

            if (stripeError) {
                toast.error(stripeError.message);
            } else if (paymentIntent && paymentIntent.status === 'succeeded') {
                await StoreAchat(clientSecret)
            } else {
                toast.error(t('payment not completed. please check your payment details'));
            }
        } catch (err) {
            console.error('Payment error:', err);
            toast.error(t('payment failed. please try again'));
        } finally {
            setIsLoading(false);
        }
    };

    const beforeUpload = (file) => {
        const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml'];
        const isValidType = validTypes.includes(file.type);

        if (!isValidType) {
            toast.error(t('invalid file type'));
            return false;
        }

        setImage(file);
        setFileName(file.name);
        return false;
    };

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            beforeUpload(file);
        });
    }, []);

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    const handlePaymentSuccessPaypal = async (orderID, payerID) => {
        setIsPaypalLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/handle-payment-paypal`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ paymentID: orderID, payerID }),
            });

            const data = await response.json();
            console.log("Payment response from backend: ", data);

            if (data.success) {
                toast.success("Payment successful");
                await StoreAchat(data.paymentID);
            } else {
                toast.error(data.error || "Payment failed");
            }
        } catch (error) {
            console.error("Error processing payment: ", error);
            toast.error("Error processing payment");
        } finally {
            setIsPaypalLoading(false);
        }
    };



    const items = [
        {
            key: '1',
            label: <span style={{ color: 'var(--primary-color3)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>{t('card details')} <CiCreditCard1 /></span>,
            children:
                <div className="row">
                    <div className="col-12 mb-3">
                        <label className="mb-2" htmlFor="card-number" style={{ color: 'var(--primary-color3)' }}>{t('card number')}</label>
                        <div className="row">
                            <div className="col-1 d-flex justify-content-center align-items-center" >
                                <span style={{ fontSize: '24px', color: 'var(--primary-color3)', paddingBottom: '10px' }} >{cardBrand == 'visa' && <RiVisaLine />}{cardBrand == 'mastercard' && <RiMastercardLine />}</span>
                            </div>
                            <div className="col-11">
                                <CardNumberElement
                                    id="card-number"
                                    options={{
                                        style: {
                                            base: {
                                                fontSize: '16px',
                                                color: '#424770',
                                                backgroundColor: 'var(--input-bg)',
                                                '::placeholder': {
                                                    color: '#aab7c4',
                                                },
                                            },
                                            invalid: {
                                                color: '#9e2146',
                                            },
                                        },
                                    }}
                                    onChange={handleCardNumberChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-4 mb-3">
                        <label className="mb-2" htmlFor="card-expiry" style={{ color: 'var(--primary-color3)' }}>{t('expiry date')}</label>
                        <CardExpiryElement
                            id="card-expiry"
                            options={{
                                style: {
                                    base: {
                                        fontSize: '16px',
                                        color: '#424770',
                                        '::placeholder': {
                                            color: '#aab7c4',
                                        },
                                    },
                                    invalid: {
                                        color: '#9e2146',
                                    },
                                },
                            }}
                        />
                    </div>
                    <div className="col-4 mb-3">
                        <label className="mb-2" htmlFor="card-cvc" style={{ color: 'var(--primary-color3)' }}>{t('cvc')}</label>
                        <CardCvcElement
                            id="card-cvc"
                            options={{
                                style: {
                                    base: {
                                        fontSize: '16px',
                                        color: '#424770',
                                        '::placeholder': {
                                            color: '#aab7c4',
                                        },
                                    },
                                    invalid: {
                                        color: '#9e2146',
                                    },
                                },
                            }}
                        />
                    </div>
                    <div className="col-4 mb-3">
                        <label className="mb-2" htmlFor="postal-code" style={{ color: 'var(--primary-color3)' }}>{t('postal code')}</label>
                        <Input
                            id="postal-code"
                            placeholder={t('enter postal code')}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>,
        },
        {
            key: '2',
            label: <span style={{ color: 'var(--primary-color3)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>{t('Paypal')} <FaPaypal /></span>,
            children: (
                <PayPalScriptProvider options={{ "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID , 
                    currency: "USD", 
                    intent: "capture"}}>
                    <PayPalButtons
                        createOrder={(data, actions) => {
                            return actions.order
                                .create({
                                    purchase_units: [
                                        {
                                            amount: {
                                                value: offre.montant,
                                            },
                                        },
                                    ],
                                })
                                .then((orderID) => {
                                    console.log("Order ID created: ", orderID);
                                    return orderID;
                                });
                        }}
                        onApprove={async (data) => {
                            if (data.orderID && data.payerID) {
                                await handlePaymentSuccessPaypal(data.orderID, data.payerID);
                            } else {
                                toast.error("OrderID or PayerID missing, payment cannot be processed.");
                            }
                        }}
                        onError={(err) => {
                            console.error("Payment error: ", err);
                            toast.error("Payment failed. Please try again");
                        }}
                    />
                </PayPalScriptProvider>
            ),
        },

    ];
    return (
        <Modal
            title={t('payment details')}
            visible={isOpen}
            onCancel={onClose}
            footer={null}
        >
            {isLoading ? <Spin style={{ display: 'block', margin: 'auto' }} /> :

                <>
                    <div style={{ marginBottom: '20px', marginTop: '20px' }}>
                        <Steps current={currentStep}>
                            <Step title={t('login')} />
                            <Step title={t('Payment')} />
                        </Steps>
                    </div>
                  

                        <Form layout="vertical" onFinish={handleSubmit}>
                            {currentStep === 0 && (
                                <>
                                    <Form.Item label={t('login')} required>
                                        <Input
                                            type="text"
                                            value={login}
                                            onChange={(e) => setLogin(e.target.value)}
                                        />
                                        <p style={{ color: 'red' }}>{error.login}</p>
                                    </Form.Item>
                                    <Form.Item label={t('password')} required>
                                        <Input
                                            type="text"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <p style={{ color: 'red' }}>{error.password}</p>
                                    </Form.Item>
                                    <Form.Item label={t('backup codes')}>
                                        <div className="row">
                                            {backupCodes.map((code, index) => (
                                                <div key={index} className="col-lg-6">
                                                    <Input
                                                        type="text"
                                                        value={code}
                                                        onChange={(e) => handleBackupCodeChange(index, e.target.value)}
                                                        style={{ marginBottom: '10px' }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                        <p style={{ color: 'red !important' }}>{error && 'Backup code is required'}</p>

                                    </Form.Item>
                                    <Form.Item label={t('whatsapp')} required>
                                        <Input
                                            type="text"
                                            value={whatsapp}
                                            onChange={(e) => setWhatsapp(e.target.value)}
                                        />
                                        <p style={{ color: 'red' }}>{error.whatsapp}</p>
                                    </Form.Item>
                                    <div className="col-lg-12 mb-3">
                                        <label htmlFor="image" style={{ color: 'var(--primary-color3)' }}>{t('upload image')}</label>
                                        <div {...getRootProps({ className: 'custom-file' })}>
                                            <input {...getInputProps()} required accept="image/jpeg,image/png,image/jpg,image/gif,image/svg+xml" />
                                            <label style={{ color: 'var(--primary-color3)' }} className="custom-file-label" htmlFor="image">
                                                {fileName || 'Choose file...'}
                                            </label>
                                            <div className="upload-zone">
                                                <span style={{ color: 'var(--primary-color3)' }}>{t('drag & drop your file here or click to upload')}</span>
                                            </div>
                                        </div>
                                        <p style={{ color: 'red' }}>{error.image}</p>
                                    </div>
                                </>
                            )}
                            {currentStep === 1 && (
                                
                                typePeyment==="stripe" ? items[0].children:items[1].children
                                
                            )}
                            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'end' }}>
                                {currentStep < 1 && (
                                    <Button type="primary" onClick={handleNext}>
                                        {t('next')}
                                    </Button>
                                )}
                                {currentStep === 1 && typePeyment === 'stripe' && (
                                    <Button type="primary" onClick={handleSubmit} loading={isLoading}>
                                        {t('submit payment')}
                                    </Button>
                                )}
                                {currentStep > 0 && (
                                    <Button style={{ margin: '0 8px' }} onClick={handlePrev}>
                                        {t('previous')}
                                    </Button>
                                )}
                            </div>
                        </Form>

                </>
            }


        </Modal>
    );
};

export default PaymentModal;